import { t } from "ttag";

import { Box, Button } from "metabase/ui";

interface EntraButtonProps {
  redirectUrl?: string;
  isCard?: boolean;
}

/**
 * Sign-in with Microsoft Entra ID: a link to the backend route that starts the
 * OpenID Connect flow (`/auth/sso/entra`). The link is relative so that it
 * follows the page's base href when Metabase is served under a path.
 */
export const EntraButton = ({ redirectUrl, isCard }: EntraButtonProps) => {
  const href = `auth/sso/entra?redirect=${encodeURIComponent(redirectUrl ?? "/")}`;

  return (
    <Box>
      <Button
        component="a"
        href={href}
        variant={isCard ? "filled" : "subtle"}
        fullWidth
      >
        {t`Sign in with Microsoft`}
      </Button>
    </Box>
  );
};
